import { render, staticRenderFns } from "./BiometricValidationIcon.vue?vue&type=template&id=22a0fa66&"
import script from "./BiometricValidationIcon.vue?vue&type=script&lang=js&"
export * from "./BiometricValidationIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports